namespace TabAurous.OMS {
    export interface MetalRateMasterRow {
        DailyRateId?: number;
        ProductTypeName?: string;
        FixedName?: string;
        MetalTypeId?: number;
        RateTypeId?: number;
        RateOn?: string;
        CurrencyId?: number;
        Rate?: number;
        FromDate?: string;
        ToDate?: string;
        CompanyId?: number;
        IsSysParam?: string;
        LossPercent?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace MetalRateMasterRow {
        export const idProperty = 'DailyRateId';
        export const nameProperty = 'RateOn';
        export const localTextPrefix = 'OMS.MetalRateMaster';
        export const lookupKey = 'OMS.MetalRateMaster';

        export function getLookup(): Q.Lookup<MetalRateMasterRow> {
            return Q.getLookup<MetalRateMasterRow>('OMS.MetalRateMaster');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            DailyRateId = "DailyRateId",
            ProductTypeName = "ProductTypeName",
            FixedName = "FixedName",
            MetalTypeId = "MetalTypeId",
            RateTypeId = "RateTypeId",
            RateOn = "RateOn",
            CurrencyId = "CurrencyId",
            Rate = "Rate",
            FromDate = "FromDate",
            ToDate = "ToDate",
            CompanyId = "CompanyId",
            IsSysParam = "IsSysParam",
            LossPercent = "LossPercent",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
